import React from "react";
import { Link } from "react-router-dom";
import moondew from "../../assets/Logo1.svg";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

export default function Footer() {
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "FAQ", path: "/faq" },
    
    { name: "Contact", path: "/contact-us" },
  ];

  const bottomLinks = [
    { name: "Buying Guide", path: "/buying-guide" },
    { name: "Warranty", path: "/warranty-coverage" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms & Conditions", path: "/terms-and-condition" },
  ];

  return (
    <footer className="flex flex-col bg-[#24522f]">
      {/* Outer container with max-width */}
      <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] w-full mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-stretch pt-14">
          {/* Left block (logo + links) */}
          <div className="flex flex-col lg:flex-row gap-5 xl:gap-12">
            {/* Logo */}
            <div className="md:flex hidden items-center lg:items-end justify-center">
              <img
                src={moondew}
                alt="Moondew Logo"
                className="h-auto w-auto bg-[#f4e391]"
              />
            </div>

            {/* Nav + Bottom Links */}
            <div className="flex flex-col justify-center">
              {/* Nav Links */}
              <ul className="flex flex-wrap justify-center lg:justify-start items-center capitalize font-lexend font-light xs:text-[12px] sm:text-[13px] text-[15px] ">
                {navLinks.map((link, index) => (
                  <li key={link.name} className="relative px-2 text-white">
                    <Link to={link.path}>{link.name}</Link>
                    {index < navLinks.length - 1 && (
                      <span className="absolute right-0 top-1/2 -translate-y-1/2 h-4 w-[2px] bg-white"></span>
                    )}
                  </li>
                ))}
              </ul>

              {/* Bottom Links */}
              <ul className="flex  flex-wrap justify-center lg:justify-start items-center font-lexend font-light xs:text-[12px] sm:text-[13px] text-[15px] capitalize mt-4">
                {bottomLinks.map((link, index) => (
                  <li key={link.name} className="relative px-2 mb-2 text-white">
                    <Link className="" to={link.path}>
                      {link.name}
                    </Link>
                    {index < bottomLinks.length - 1 && (
                      <span className="absolute right-0 top-1/2 -translate-y-1/2 h-4 w-[2px] bg-white"></span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right block (social icons + copyright) */}
          <div className="mt-6 lg:mt-0 text-center flex flex-col lg:text-right justify-center items-center">
            <ul className="flex justify-center lg:justify-end items-center gap-3">
              <li className="bg-[#f4e391] w-8 h-8 rounded-full flex justify-center items-center">
                <FacebookOutlinedIcon sx={{ color: "#24522f" }} />
              </li>
              <li className="bg-[#f4e391] w-8 h-8 rounded-full flex justify-center items-center">
                <InstagramIcon sx={{ color: "#24522f" }} />
              </li>
              <li className="bg-[#f4e391] w-8 h-8 rounded-full flex justify-center items-center">
                <XIcon sx={{ color: "#24522f" }} />
              </li>
              <li className="bg-[#f4e391] w-8 h-8 rounded-full flex justify-center items-center">
                <YouTubeIcon sx={{ color: "#24522f" }} />
              </li>
              <li className="bg-[#f4e391] w-8 h-8 rounded-full flex justify-center items-center">
                <LinkedInIcon sx={{ color: "#24522f" }} />
              </li>
            </ul>

            <p className="capitalize pt-2 pb-7 xs:text-[12px] sm:text-[13px] text-[15px] text-[#508656] font-lexend font-light">
              &copy; 2026 moondew. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
      {/* Logo */}
      <div className="flex md:hidden items-center lg:items-end justify-center">
        <img
          src={moondew}
          alt="Moondew Logo"
          className="h-auto xs:w-[130px] sm:w-[160px] w-44 bg-[#f4e391]"
        />
      </div>
      {/* Bottom Yellow Bar */}
      <div className="bg-[#f4e391] h-2"></div>
    </footer>
  );
}
